import { createAsyncThunk } from "@reduxjs/toolkit";
import { postExport, postRequest } from "../apiHelpers";
import {
	exportAgent, exportCustomer, exportNearlyExpired, exportRiskVehicleContract, exportAgentCommission,
	exportLifeContract, exportVehicleContract, exportLifeContractPDF, exportVehicleContractPdfURL,
	exportHistory,
	getExportClameURL,
	exportExcelClameURL,
	getExportClameSummaryURL,
	exportExcelClameSummaryURL,
	getExportVehicleSummaryURL,
	exportClameContractPDF,
	exportExcelSummaryURL,
	getExportAgent,
	commisionAgentPdfURL,
	exportClameVehicleContractPDF
} from "../pathApi";
import SwalAlert from "../../components/common/alert";

export const callExportAgent = async (body) => {
	try {
		const response = await postExport({ url: exportAgent, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};

export const callExportLifeContractPDF = async (body) => {
	try {
		const response = await postExport({ url: exportLifeContractPDF, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};
export const callExportCommissionPDF = async (body) => {
	try {
		const response = await postExport({ url: commisionAgentPdfURL, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};
export const callExportVehicleContractPDF = async (body) => {
	try {
		const response = await postExport({ url: exportVehicleContractPdfURL, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};
export const callExportCustomer = async (body) => {
	try {
		const response = await postExport({ url: exportCustomer, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};

export const callExportNearlyExpired = async (body) => {
	try {
		const response = await postExport({ url: exportNearlyExpired, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};

export const callExportRiskVehicleContract = async (body) => {
	try {
		const response = await postExport({ url: exportRiskVehicleContract, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};

export const callExportAgentCommission = async (body) => {
	try {
		const response = await postExport({ url: exportAgentCommission, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};

export const callExportLifeContract = async (body) => {
	try {
		const response = await postExport({ url: exportLifeContract, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};

export const callExportVehicleContract = async (body) => {
	try {
		const response = await postExport({ url: exportVehicleContract, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};

export const callExportHistory = async (body) => {
	try {
		const response = await postExport({ url: exportHistory, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};
export const callExportClame = createAsyncThunk(getExportClameURL, async (body) => {
	try {
		const response = await postRequest({ url: getExportClameURL, data: body });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
});
export const callExportClameExcel = async (body) => {
	try {
		const response = await postExport({ url: exportExcelClameURL, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};
export const getExportClameSummary = createAsyncThunk(getExportClameSummaryURL, async (body) => {
	try {
		const response = await postRequest({ url: getExportClameSummaryURL, data: body });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
});
export const callExportClameSummaryExcel = async (body) => {
	try {
		const response = await postExport({ url: exportExcelClameSummaryURL, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};
export const callExportSummaryExcel = async (body) => {
	try {
		const response = await postExport({ url: exportExcelSummaryURL, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};
export const getExportVehicleSummary = createAsyncThunk(getExportVehicleSummaryURL, async (body) => {
	try {
		const response = await postRequest({ url: getExportVehicleSummaryURL, data: body });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
});
export const callExportClamePDF = async (body) => {
	try {
		const response = await postExport({ url: exportClameContractPDF, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};
export const getLocalExportVehicleSummary = createAsyncThunk(exportVehicleContractPdfURL, async (body) => {
	try {
		const response = await postRequest({ url: exportVehicleContractPdfURL, data: body });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
});
export const callExportClameVehiclePDF = async (body) => {
	try {
		const response = await postExport({ url: exportClameVehicleContractPDF, data: body, responseType: "blob" });
		return response;
	} catch (error) {
		throw error.response?.data || "An error occurred";
	}
};